<template>
  <div class="HomeVideo">
    <div class="hvLeft">
      <ul>
        <li
          v-for="(item, index) in msg.recommend"
          :key="index"
          @click="toZxDetail(item.id)"
        >
          <div class="dian"></div>
          <div class="listText">
            {{ item.title }}
          </div>
        </li>
      </ul>
    </div>
    <div class="hvRight">
      <ul class="hvRlist">
        <li
          class="hvRlistIn"
          v-for="(item, index) in msg.recommend_2"
          :key="index"
          @click="toZxDetail(item.id)"
        >
          <van-image width="15rem" height="10rem" lazy-load :src="item.img1" />
          <div class="hvRname">
            {{ item.title }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeVideo",
  data() {
    return {};
  },
  props: ["msg"],
  methods: {
    toZxDetail(id) {
      // this.$router.push({ name:'InfDetail', params: { id: id} } )
      window.open("https://yooobei.com/#/InfDetail?id=" + id);
      // this.$emit('change2', '1')
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

.HomeVideo{
    height 21rem
    padding .9375rem 0
    display flex
}
.hvLeft{
    position relative
}
.hvLeft ul{
    width 22rem
    padding-left 1.25rem
    margin 0
}
.hvLeft li{
  display flex
  align-items center
  font-size:1rem;
  font-weight:500;
  color:#000;
  line-height 2.1rem;
  cursor pointer
  width 21.875rem
}
.hvLeft li:hover{
    color rgba(255, 94, 4, 1)
}
.dian{
  width:.25rem;
  height:.25rem;
  background:#000;
  border-radius:50%;
  margin-right .3125rem
}
.listText{
  width 22rem
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis
}
.hvLname{
    width 40rem
    height 2.5rem
    line-height 2.5rem
    text-align center;
    background rgba(0, 0, 0, 0.4)
    position absolute
    left 0
    bottom .25rem
    color #fff
}
.hvRight{
    margin-left 3.125rem
    padding-bottom .25rem
}
.hvRlist{
    height 100%
    display flex
    flex-wrap wrap
    justify-content space-between
    align-content space-between
}
.hvRname{
    position absolute
    left 0
    bottom .25rem
    width  15rem;
    height:1.875rem;
    background:rgba(0,0,0,0.3);
    line-height 1.875rem
    text-align center
    color #fff
    cursor pointer
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis
    font-size 0.8rem
    padding 0 .625rem
    box-sizing border-box
}
.hvRname:hover{
    background  rgba(255, 94, 4, 1)
}
.hvRlist{
    display flex
}
.hvRlistIn{
    position relative
    cursor pointer
}
</style>
